import { render, staticRenderFns } from "./claimDetails.vue?vue&type=template&id=41c02073&scoped=true&"
import script from "./claimDetails.vue?vue&type=script&lang=js&"
export * from "./claimDetails.vue?vue&type=script&lang=js&"
import style0 from "./claimDetails.vue?vue&type=style&index=0&id=41c02073&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c02073",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41c02073')) {
      api.createRecord('41c02073', component.options)
    } else {
      api.reload('41c02073', component.options)
    }
    module.hot.accept("./claimDetails.vue?vue&type=template&id=41c02073&scoped=true&", function () {
      api.rerender('41c02073', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/claimDetails.vue"
export default component.exports